import axios from 'axios';
import {handleError, handleResponse} from '../../../api/network/apiUtils';
import {CANCEL_API_REQUEST, API_REQUEST, apiCallCancelled, GET, apiCallSuccess, apiCallStarted, apiCallError} from '../../actions/ApiCallsActions';


const instance = axios.create();
const cancelTokens = {};

/**
 * Api Middleware for redux that handles all api calls with axios.
 */
export default ({dispatch}) => next => action => {
    next(action);
    if (!action.payload) return;

    const {
        entity,
        url,
        method,
        data,
        config,
        meta
    } = action.payload;

    const {CancelToken} = axios;

    if (action.type.includes(API_REQUEST)) {
        dispatch(apiCallStarted(entity));
        if (method === GET) {
            instance.request({
                url,
                method,
                params: data,
                headers: config,
                cancelToken: new CancelToken((c => {
                    // An executor function receives a cancel function as a parameter
                    if (!cancelTokens[entity]) cancelTokens[entity] = [];
                    cancelTokens[entity].push(c);
                }))
            })
                .then(handleResponse)
                .then(data => {
                    dispatch(apiCallSuccess(data, entity, meta));
                })
                .catch(e => {
                    if (axios.isCancel(e)) {
                        console.log(`request cancelled:${e.message}`);
                        dispatch(apiCallCancelled(entity));
                        return true;
                    }
                    throw e;
                })
                .catch(handleError)
                .catch(error => {
                    console.error(error);
                    dispatch(apiCallError(error, entity, meta));
                })
                .finally(_ => {
                    // Clean up
                    if (cancelTokens[entity]) delete cancelTokens[entity];
                });
        } else {
            instance.request({url, method, data, headers: config})
                .then(handleResponse)
                .then(_ => {
                    dispatch(apiCallSuccess(data, entity, meta));
                })
                .catch(e => {
                    if (axios.isCancel(e)) {
                        console.log(`request cancelled:${e.message}`);
                        dispatch(apiCallCancelled(entity));
                    } else {
                        throw e;
                    }
                })
                .catch(handleError)
                .catch(error => {
                    dispatch(apiCallError(error, entity, meta));
                })
                .finally(_ => {
                    // Clean up
                    if (cancelTokens[entity]) delete cancelTokens[entity];
                });
        }
    }

    if (action.type === CANCEL_API_REQUEST) {
        if (!cancelTokens[entity]) return;

        // cancel all the request for the specified entity
        cancelTokens[entity].forEach(cancel => cancel());
        if (cancelTokens[entity]) delete cancelTokens[entity];
    }
};
